<nav
  id="listing-group"
  class="listing-group"
  [ngClass]="{ 'half-creen-map': fullScreen }"
>
  <ion-button
    *ngFor="let item of mapTypes"
    [ngClass]="{ 'active': mapService.styleId == item.value }"
    (click)="switchLayer(item.value)"
    >{{ item.name }}</ion-button
  >
</nav>
